module.exports = "<div [id]=\"idEl\" [class]=\"class\">\n    <div\n        id=\"active\"\n        [style]=\"backgroundColor\"\n        class=\"bdb-at-backdrop--active\"\n        (click)=\"tabBackdrop($event)\"\n    >\n        <div\n            id=\"content-slot\"\n            class=\"bdb-at-backdrop__content animated\"\n            [style]=\"alignItems\"\n        >\n            <slot name=\"bodyBackdrop\"></slot>\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/webcomponents/bdb-backdrop/bdb-backdrop.component.html
// module id = ./src/webcomponents/bdb-backdrop/bdb-backdrop.component.html
// module chunks = main